import React from "react";
import "./styles.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="wrap">© YardYard 2022</div>
    </footer>
  );
};

export default Footer;
